import React from 'react';
function index(_a) {
    var logo = _a.logo, user_nick = _a.user_nick, guest = _a.guest;
    return (React.createElement("div", { className: "im-nav" },
        React.createElement("div", { className: "nav-main" },
            React.createElement("div", { className: "nav-txt" },
                React.createElement("img", { src: logo, className: "nav-logo", alt: "" }),
                "\u5728\u7EBF\u670D\u52A1"),
            React.createElement("div", { className: "im-user" },
                guest ? React.createElement("span", null, "\u4F60\u597D\uFF01\u6E38\u5BA2") : React.createElement("span", null, "\u4F60\u597D\uFF01"),
                React.createElement("span", { className: "user-nick" }, user_nick)))));
}
export default index;
